import angular from 'angular';

class InitBindController {
  constructor($rootScope, $compile) {
    this.$rootScope = $rootScope;
    this.$compile = $compile;
  }
}

InitBindController.$inject = ['$rootScope', '$compile'];

class InitBindDirective {

  constructor() {
    this.restrict = "A";
    this.replace = true;
    this.controller = InitBindController;
  }

  link(scope, element, attrs, ctrl) {
    scope.$watch(attrs.dynamic, function(html) {
      element.html(html);
      ctrl.$compile(element.contents())(scope);
    });
  }

  // static directiveFactory() {
  //   return new InitBindDirective();
  // }
}

export default angular
.module('initBind.directive', [])
.directive('initBind', () => new InitBindDirective())
.name;
